export default __webpack_public_path__ + "media/images/icons/sliders-h-solid-af63a635a58f1b054c57b5943c7bc389.svg";